(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-ugc"] && !Shopify.designMode) return;
  try {
    const ugcVideos = document.querySelectorAll(".pdp-ugc video");
    const videoPopup = document.querySelector(".pdp-ugc-video-popup");
    const popupVideo = videoPopup.querySelector("video");
    const closeBtn = videoPopup.querySelector(".close-btn");

    let currentIndex = 0;

    function resetVideoToPoster(video) {
        video.pause();
        video.currentTime = 0;

        // Force browser to unload the frame it was on
        const src = video.src;
        video.removeAttribute("src");
        video.load(); // clears the current frame

        // Reapply source so it can play again later
        video.src = src;

        // This enables the poster to show
    }
    /*
    function playNextVideo() {
        if (currentIndex >= ugcVideos.length) {
             currentIndex = 0;
            playNextVideo();
            return;
        }

        var video = ugcVideos[currentIndex];

        video.currentTime = 0;
        //playVideoForFiveSeconds(video)
        
        video.play().then(() => {
            setTimeout(() => {
                //resetVideoToPoster(video);

                currentIndex++;
                playNextVideo();
            }, 5000); // 5 seconds
        }).catch(err => {
            console.error("Could not play video:", err);
            currentIndex++;
            playNextVideo();
        });
        
}*/

// Start playing sequence
//playNextVideo();

function setDynamicMobileVideoHeight(video) {
    if (window.innerWidth >= 768) return; // desktop → ignore

    // Get the real video aspect ratio
    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;

    if (!videoWidth || !videoHeight) {
        // Try again when metadata loads
        video.addEventListener("loadedmetadata", () => setDynamicMobileVideoHeight(video), { once: true });
        return;
    }

    const aspectRatio = videoHeight / videoWidth;

    const newHeight = window.innerWidth * aspectRatio; // H = W * ratio

    //videoPopup.style.height = newHeight + "px !important";
    videoPopup.style.setProperty("height", newHeight + "px", "important");

}


ugcVideos.forEach(video => {
    video.addEventListener("click", function () {
        
        popupVideo.src = this.src || this.querySelector("source").src;

        popupVideo.currentTime = 0;
        popupVideo.play();

        videoPopup.style.display = "block";

        setDynamicMobileVideoHeight(popupVideo);
        
    });
});



closeBtn.addEventListener("click", () => {
    popupVideo.pause();
    videoPopup.style.display = "none";
});


// SAFE LOOPING SEQUENTIAL VIDEO PLAYER (low-battery safe)
(function () {
  var videos = [];
  var currentIndex = 0;
  var active = false;

  function resetToPoster(video) {
    if (!video) return;
    try {
      video.pause();
      video.currentTime = 0;

      // force poster frame on iOS / low-power
      video.removeAttribute("src");
      var src = video.getAttribute("data-src") || video.currentSrc;
      if (src) video.src = src;

      video.load();
    } catch (e) {}
  }

  function advance() {
    active = false;

    // reset video that just finished
    resetToPoster(videos[currentIndex]);

    currentIndex++;
    if (currentIndex >= videos.length) {
      currentIndex = 0; // loop back to first
    }

    safePlay(videos[currentIndex]);
  }

  function safePlay(video) {
    if (active) return;
    active = true;

    var done = false;
    var started = false;
    var startCT = 0;
    var raf = null;
    var retryRAF = null;

    function finish() {
      if (done) return;
      done = true;
      cleanup();
      advance();
    }

    function cleanup() {
      if (raf) cancelAnimationFrame(raf);
      if (retryRAF) cancelAnimationFrame(retryRAF);

      video.removeEventListener("playing", onPlaying);
      video.removeEventListener("ended", finish);
      document.removeEventListener("visibilitychange", onVis);
    }

    function onPlaying() {
      started = true;
      startCT = video.currentTime || 0;
      tick();
    }

    function tick() {
      if (done) return;

      if ((video.currentTime - startCT) >= 5) {
        finish();
        return;
      }

      if (video.paused && started) {
        finish();
        return;
      }

      raf = requestAnimationFrame(tick);
    }

    function tryPlayLoop() {
      if (done) return;

      try {
        var p = video.play();
        if (p && p.catch) {
          p.catch(function () {
            retryRAF = requestAnimationFrame(tryPlayLoop);
          });
        }
      } catch (e) {
        retryRAF = requestAnimationFrame(tryPlayLoop);
      }
    }

    function onVis() {
      if (!document.hidden && !started) {
        tryPlayLoop();
      }
    }

    // HARD RESET before play
    resetToPoster(video);

    video.muted = true;
    video.playsInline = true;
    video.preload = "metadata";
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");

    video.addEventListener("playing", onPlaying);
    video.addEventListener("ended", finish);
    document.addEventListener("visibilitychange", onVis);

    tryPlayLoop();
  }

  function boot() {
    videos = document.querySelectorAll(".pdp-ugc video");
    if (!videos.length) return;

    currentIndex = 0;
    safePlay(videos[currentIndex]);
  }

  window.addEventListener("load", function () {
    requestAnimationFrame(boot);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
